import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showSection
    ? _c(
        "section",
        {
          staticClass: "lpu-interview d-flex flex-column",
          class: _setup.isMobile ? "lpu-interview--mobile ga-4" : "ga-8",
          attrs: { id: "interview", "data-qa": "lpu_interview" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text--text ma-0",
              class: _setup.isMobile ? "text-h6" : "text-h5",
              attrs: { "data-qa": "lpu_interview_title" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.tStatic("Интервью с руководителем")) +
                  "\n    "
              ),
              _setup.adminHref
                ? _c(
                    "a",
                    {
                      staticClass: "adminka ml-2",
                      attrs: {
                        href: _setup.adminHref,
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.tStatic("Править интервью")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lpu-interview__body",
              class: _setup.isMobile
                ? "d-flex flex-column ga-4"
                : "d-flex align-start ga-6",
            },
            [
              _setup.photoSrc
                ? _c(VImg, {
                    staticClass:
                      "rounded-30 bg-lpu-branding-color-background flex-grow-0 flex-shrink-0",
                    attrs: {
                      contain: "",
                      width: _setup.isMobile ? "100%" : 300,
                      "max-width": "100%",
                      "aspect-ratio": _setup.isMobile ? 4 / 3 : undefined,
                      src: _setup.photoSrc,
                      alt: _setup.photoAlt,
                      "data-qa": "lpu_interview_photo",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "lpu-interview__main d-flex flex-column min-w-0 ga-6",
                },
                [
                  _c("div", {
                    staticClass:
                      "lpu-interview__text text-body-1 text--text text-break",
                    class: {
                      "lpu-interview__text--expanded": _setup.isExpanded,
                    },
                    attrs: { "data-qa": "lpu_interview_text" },
                    domProps: {
                      innerHTML: _vm._s(
                        _setup.textHtml /* eslint-disable-line vue/no-v-html */
                      ),
                    },
                  }),
                  _vm._v(" "),
                  !_setup.isMobile
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "lpu-interview__more align-self-start text-link-1 text-decoration-underline primary--text",
                          attrs: {
                            type: "button",
                            "data-qa": "lpu_interview_toggle",
                          },
                          on: { click: _setup.toggleExpanded },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.desktopToggleLabel) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        VBtn,
                        {
                          staticClass:
                            "lpu-interview__toggle branding-btn branding-btn--primary rounded-20 text-subtitle-1 text-none w-100",
                          attrs: {
                            depressed: "",
                            height: "52",
                            block: true,
                            "data-qa": "lpu_interview_toggle",
                          },
                          on: { click: _setup.toggleExpanded },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.mobileToggleLabel) +
                              "\n      "
                          ),
                        ]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }